// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2eesL","footer":"ModalUpdate_footer__BOtUk"};